import { Badge, BadgeSize, BadgeVariant } from "shared/components";
import { Card } from "shared/components/Card";
import SuccessIcon from "shared/icons/status-icons/success-icon.svg?react";
import { VerticalSpacer } from "./components/VerticalSpacer";
import { RuleSet, RuleSetDecision } from "./types";
import { RuleSetCard } from "./components/RuleSetCard";
import { defaultRuleSet } from "./constants";
import { useTemplateContext } from "shared/app/VerificationTemplate/provider";
import { Template } from "types/landlord/verificationTemplate";
import { Dispatch, SetStateAction } from "react";

export const RuleCriteria = () => {
  const { template, setTemplate } = useTemplateContext();

  const ruleSets = template?.rule_criteria || defaultRuleSet;
  const setRuleSets: Dispatch<SetStateAction<RuleSet[]>> = (
    v: RuleSet[] | ((v: RuleSet[]) => RuleSet[])
  ) => {
    if (typeof v === "function") {
      const newRules = v(ruleSets);

      setTemplate({
        ...(template as Template),
        rule_criteria: newRules
      });
      return;
    } else
      setTemplate({
        ...(template as Template),
        rule_criteria: v
      });
  };

  const declineRuleSets = ruleSets.filter(
    (rs) => rs.type === RuleSetDecision.Decline
  );
  const approveRuleSets = ruleSets.filter(
    (rs) => rs.type === RuleSetDecision.Approve
  );

  return (
    <div className="bg-background-900">
      <RuleSetCard
        ruleSets={declineRuleSets}
        ruleNumber={1}
        decision={RuleSetDecision.Decline}
        setRuleSets={setRuleSets}
      />

      <VerticalSpacer height={24} className="ml-[118px]" />
      <Badge className="ml-4" variant={BadgeVariant.BASE} size={BadgeSize.SM}>
        If condition above wasn&apos;t met
      </Badge>
      <VerticalSpacer height={24} className="ml-[118px]" />

      <RuleSetCard
        ruleSets={approveRuleSets}
        ruleNumber={2}
        decision={RuleSetDecision.Approve}
        setRuleSets={setRuleSets}
      />

      <VerticalSpacer height={24} className="ml-[118px]" />
      <Badge className="ml-4" variant={BadgeVariant.BASE} size={BadgeSize.SM}>
        If condition above wasn&apos;t met
      </Badge>
      <VerticalSpacer height={24} className="ml-[118px]" />

      <Card>
        <div className="px-6 py-5 flex items-center gap-2">
          <SuccessIcon className="w-5 text-warning-500" />
          <h2 className="text-base font-bold text-content-1000">
            3. Recommend conditional approval
          </h2>
        </div>
      </Card>
    </div>
  );
};
